import React from "react";
import { toggleYear } from "../../Redux/Actions/activeYear";
import { useSelector, useDispatch } from "react-redux";

const YearButtons = () => {
  const activeYear = useSelector((state) => state.year);
  const dispatch = useDispatch();
  const yearHandler = (value) => {
    dispatch(toggleYear(value));
  };

  return (
    <div className="container-button-year-mobile">
      <div
        className={`${
          activeYear.year === "year1"
            ? "button-year-mobile-focused"
            : "button-year-mobile"
        }`}
        onClick={() => yearHandler({ ...activeYear, year: "year1" })}
      >
        År 1
      </div>

      <div
        className={`${
          activeYear.year === "year2"
            ? "button-year-mobile-focused"
            : "button-year-mobile"
        }`}
        onClick={() => yearHandler({ ...activeYear, year: "year2" })}
      >
        År 2
      </div>

      <div
        className={`${
          activeYear.year === "year3"
            ? "button-year-mobile-focused"
            : "button-year-mobile"
        }`}
        onClick={() => yearHandler({ ...activeYear, year: "year3" })}
      >
        År 3
      </div>
    </div>
  );
};
export default YearButtons;
